import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { DOWNLOADS_INITIAL_STATE, SLICE_NAMESPACE } from './downloads.constants';
import { reducers } from './downloads.reducers';

const downloadsSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState: DOWNLOADS_INITIAL_STATE,
  reducers,
  extraReducers,
});

export const { updateDownloadFilterReportType, updateDownloadReportListPage, setDownloadReportListStatus } =
  downloadsSlice.actions;

export default downloadsSlice.reducer;
